/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

import { useCallback, useEffect, useState } from "react";

/** Which machine the speed widgets look at: "local" (the panel's host) or an agent id. */
export const LOCAL_SOURCE = "local";
const KEY = "nyrvex-home-speedtest-src";
const EVENT = "nyrvex-speed-source";

function read(): string {
  try {
    return localStorage.getItem(KEY) || LOCAL_SOURCE;
  } catch {
    return LOCAL_SOURCE;
  }
}

/** The chosen machine, shared by the Home widget and the Network overview (same tab and other tabs). */
export function useSpeedSource(): [string, (v: string) => void] {
  const [src, setSrc] = useState(read);
  useEffect(() => {
    const sync = () => setSrc(read());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);
  const pick = useCallback((v: string) => {
    try {
      localStorage.setItem(KEY, v);
    } catch {
      /* ignore */
    }
    setSrc(v);
    window.dispatchEvent(new Event(EVENT));
  }, []);
  return [src, pick];
}
